import {
  usePathname as useLocalizedPathname,
  useRouter,
} from '@/i18n/navigation'
import { usePathname, useSearchParams } from 'next/navigation'
import { useCallback } from 'react'
import { updateHistoryState } from '../lib/utils/routing'

type ParamValue = string | undefined | null

export const useUpdateSearchParams = () => {
  const searchParams = useSearchParams()
  const router = useRouter()
  const pathname = usePathname()
  const localizedPathname = useLocalizedPathname()

  const updateSearchParam = useCallback(
    (
      params: Record<string, ParamValue | ParamValue[]>,
      { clientOnly }: { clientOnly?: boolean } = {},
    ) => {
      const query = new URLSearchParams(searchParams)

      Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          query.delete(key)
          value.forEach(v => v && query.append(key, v))
        } else if (value) {
          query.set(key, value)
        } else {
          query.delete(key)
        }
      })

      if (clientOnly) {
        updateHistoryState(`${pathname}?${query.toString()}`)
      } else {
        router.replace({
          pathname: `${localizedPathname}?${query.toString()}`,
        })
      }
    },
    [router, pathname, localizedPathname, searchParams],
  )

  return { searchParams, updateSearchParam }
}
